module.exports = __webpack_public_path__ + "static/media/1.b00400ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/accessoires/1.png
// module id = 1114
// module chunks = 0